module.exports = __webpack_public_path__ + "media/images/icon-certificate-20e60fb1.png";